import bmgf from '../../projects/img/pastClients/bmgf.png';
import patagonia from '../../projects/img/pastClients/patagonia.png';
import lls from '../../projects/img/pastClients/lls.png';
import amazon from '../../projects/img/pastClients/amazon.png';
import airbus from '../../projects/img/clients/wb.png';
import salesforce from '../../projects/img/pastClients/salesforce.png';

let pastClients = [
    {
        img: bmgf,
        alt: "Bill & Melinda Gates Foundation logo",
    },
    {
        img: patagonia,
        alt: "Patagonia logo",
    },
    {
        img: lls,
        alt: "LLSlogo",
    },
    
    {
        img: amazon,
        alt: "Amazon logo",
    },
    {
        img: airbus,
        alt: "Airbuslogo",
    },
    {
        img: salesforce,
        alt: "Salesforce logo",
    },
];

export default pastClients;